import { MaskitoOptions } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';

export const digitsOnlyMask: MaskitoOptions = {
  mask: /^\d+$/,
};

const genericOptions = {
  precision: 8,
  min: 0,
  thousandSeparator: '',
};

export const createCollateralInputMask = (
  ...p: Parameters<typeof maskitoNumberOptionsGenerator>
) => {
  return maskitoNumberOptionsGenerator({
    ...genericOptions,
    ...p[0],
  });
};
export const createLiquidityInputMask = (
  ...p: Parameters<typeof maskitoNumberOptionsGenerator>
) => {
  return maskitoNumberOptionsGenerator({
    ...genericOptions,
    ...p[0],
  });
};
